module.exports = __webpack_public_path__ + "img/meetingfenxi.4fbab221.png";